export const GOOGLE_REGISTRATION_SUCCESS_EVENT_NAME = 'Account Created - Google Sign In';

// NOTE: All collections of events should use the SAME SET OF EVENT CONSTANTS FROM ABOVE.
// This means 1 event per app actions shared between X number of analytics programs
export const GOOGLE_ANALYTICS_SUPPORTED_EVENTS = [
  GOOGLE_REGISTRATION_SUCCESS_EVENT_NAME,
];
